

















































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

import Auth from "@aws-amplify/auth";

@Component
export default class CompleteNewPassword extends Vue {
  @Getter("auth/cognitoUser") public cognitoUser: any;
  @Getter("auth/isSupport") public isSupport: boolean;
  @Getter("auth/isAdministrator") public isAdministrator: boolean;

  public password: string = "";
  public passwordConfirm: string = "";
  public currentyear: number = new Date().getFullYear();
  public showPassword: boolean = false;

  public updatePassword() {
    // console.log('updatePassword()', 'this.cognitoUser', this.cognitoUser);
    Auth.completeNewPassword(this.cognitoUser, this.password, {})
      .then((user: any) => {
        // console.log(user);
        if (this.isSupport) {
          this.$router.push({ name: "onecentralsupport" });
        } else if (this.isAdministrator) {
          this.$router.push({ name: "list-client" });
        } else {
          this.$router.push({ name: "reports" });
        }
      })
      .catch((err: any) => this.$onecentral.displayError(err));
  }

  public toggleShow() {
    this.showPassword = !this.showPassword;
  }
}
